import React, { useState } from 'react';
import styled from 'styled-components';

const AboutNavWrapper = styled.nav`
	&.hostjane-main-About-Nav {
		position: sticky;
		top: 0;
		left: 0;
		width: 100%;
		height: 52px;
		z-index: 9997;
		margin: 0;
		padding: 0;
		pointer-events: auto;
		letter-spacing: normal;
		.hostjane-main-About-Nav__wrapper {
			position: absolute;
			top: 0;
			left: 0;
			bottom: 0px;
			width: 100%;
			height: auto;
			min-height: 100%;
			z-index: 1;
			.hostjane-main-About-Nav__wrapper__background {
				background-color: rgba(255, 255, 255, 1);
				position: absolute;
				left: 0;
				top: 0;
				width: 100%;
				height: 100%;
				z-index: 1;
				transition: background-color 0.5s
					cubic-bezier(0.28, 0.11, 0.32, 1);
				min-height: 48px;
				&:after {
					margin-left: 0;
					left: 0;
					width: 100%;
					content: '';
					display: block;
					position: absolute;
					top: 100%;
					height: 1px;
					z-index: 1;
					background-color: rgba(0, 0, 0, 0.16);
				}
			}
			.hostjane-main-About-Nav__wrapper__content {
				width: 100%;
				margin: 0 auto;
				max-width: ${props => (props.fullWidth ? '1440px' : '980px')};
				padding-left: ${props =>
					props.fullWidth
						? '28px'
						: 'calc(max(22px, env(safe-area-inset-left)))'};
				padding-right: ${props =>
					props.fullWidth
						? '20px'
						: 'calc(max(22px, env(safe-area-inset-right)))'};
				position: relative;
				z-index: 2;
				&:before {
					content: ' ';
					display: table;
				}
				&:after {
					clear: both;
					content: ' ';
					display: table;
				}
				backdrop-filter: saturate(180%) blur(20px);
				.hostjane-main-About-Nav__wrapper__content__title {
					color: black;
					transition: color 0.5s cubic-bezier(0.28, 0.11, 0.32, 1);
					font-size: 21px;
					line-height: 1.14286;
					font-weight: 600;
					letter-spacing: 0.011em;
					cursor: default;
					display: block;
					float: left;
					margin: 0px 0 -14px;
					padding: 0;
					padding-top: 14px;
					height: 52px;
					white-space: nowrap;

					a {
						svg {
							width: ${props =>
								props.smallNavIcon ? '50px' : '160px'};
							height: ${props =>
								props.smallNavIcon ? '30px' : '25px'};
						}

						display: flex;
						-webkit-box-orient: vertical;
						-webkit-box-direction: reverse;
						flex-direction: column-reverse;
						letter-spacing: inherit;
						line-height: inherit;
						margin: 0;
						text-decoration: none;
						white-space: nowrap;
						opacity: 0.88;
						color: black;
						flex-direction: row;
						align-items: center;
					}
				}
				.hostjane-main-About-Nav__wrapper__content__menu {
					font-size: 16px;
					line-height: 1;
					font-weight: 400;
					letter-spacing: -0.01em;
					float: right;
					margin-top: -3px;
					padding-top: 18px;
					@media screen and (max-width: 992px) {
						width: 100%;
					}
					.hostjane-main-About-Nav__wrapper__content__menu__anchor-open {
						display: none;
						position: absolute;
						top: 0;
						left: 0;
						width: 1px;
						height: 1px;
						z-index: 10;
						color: #0070c9;
						span {
							position: absolute;
							clip: rect(1px, 1px, 1px, 1px);
							clip-path: inset(0px 0px 99.9% 99.9%);
							overflow: hidden;
							height: 1px;
							width: 1px;
							padding: 0;
							border: 0;
						}
					}
					.hostjane-main-About-Nav__wrapper__content__menu__anchor-close {
						display: none;
						position: absolute;
						top: 0;
						left: 0;
						width: 1px;
						height: 1px;
						z-index: 10;
						color: #0070c9;
						span {
							position: absolute;
							clip: rect(1px, 1px, 1px, 1px);
							-webkit-clip-path: inset(0px 0px 99.9% 99.9%);
							clip-path: inset(0px 0px 99.9% 99.9%);
							overflow: hidden;
							height: 1px;
							width: 1px;
							padding: 0;
							border: 0;
						}
					}
					.hostjane-main-About-Nav__wrapper__content__menu__tray {
						float: left;
						// padding-top: 4px;
						@media screen and (max-width: 992px) {
							float: none;
							overflow: hidden;
							pointer-events: none;
							visibility: hidden;
							width: 100%;
							padding-top: 0;
							max-height: 0;
							-webkit-transition: max-height 0.5s
									cubic-bezier(0.28, 0.11, 0.32, 1) 0.4s,
								visibility 0s linear 1s;
							transition: max-height 0.5s
									cubic-bezier(0.28, 0.11, 0.32, 1) 0.4s,
								visibility 0s linear 1s;
							ul {
								opacity: 1;
								padding: 4px 24px 24px;
								&.active {
									opacity: 1;
								}

								.menu-item {
									margin-left: 0;
									display: inline-block;
									float: none;
									width: 100%;
									height: 44px;

									a {
										width: 100%;
										border-top: 1px solid
											rgba(0, 0, 0, 0.181818);
										display: -webkit-box;
										display: -ms-flexbox;
										display: flex;
										-webkit-box-align: center;
										-ms-flex-align: center;
										align-items: center;
										height: 100%;
										line-height: 1.3;
										opacity: 0;
										transform: translate3d(0, -25px, 0);
										transition: 0.5s ease;
										transition-property: transform, opacity,
											-webkit-transform;
										&.active {
											opacity: 0.88;
											transform: translate3d(0, 0, 0);
										}
									}
									&:nth-child(1) {
										a {
											transition-delay: 0.07s;
											border-top: 0;
											&.active {
												transition-delay: 0.56s;
											}
										}
									}
									&:nth-child(2) {
										a {
											transition-delay: 0.14s;
											&.active {
												transition-delay: 0.49s;
											}
										}
									}
									&:nth-child(3) {
										a {
											transition-delay: 0.21s;
											&.active {
												transition-delay: 0.42s;
											}
										}
									}
									&:nth-child(4) {
										a {
											transition-delay: 0.28s;
											&.active {
												transition-delay: 0.35s;
											}
										}
									}
								}
							}
						}
						&.active {
							max-height: calc(100vh - 48px - 48px);
							overflow-y: auto;
							pointer-events: auto;
							visibility: visible;
							transition-delay: 0.2s, 0s;
						}
						ul {
							margin: 0;
							list-style: none;
							letter-spacing: inherit;
							li {
								margin-left: 24px;
								float: left;
								list-style: none;
								box-sizing: content-box;
								pointer-events: auto;
								a {
									color: #000;
									display: inline-block;
									line-height: 22px;
									white-space: nowrap;
									opacity: 0.88;
									text-decoration: none;
								}
							}
						}
					}
					.hostjane-main-About-Nav__wrapper__content__menu__action {
						float: left;
						@media screen and (max-width: 992px) {
							padding-left: 16px;
							padding-right: 16px;
							padding-top: 16px;
							right: 0;
							position: absolute;
							top: 0;
							z-index: 1;
						}
						.hostjane-main-About-Nav__wrapper__content__menu__action__menu-cta {
							display: none;
							position: relative;
							z-index: 1;
							margin-left: 24px;
							float: left;
							@media screen and (max-width: 992px) {
								display: block;
							}
							label {
								margin-right: -11px;
								cursor: pointer;
								display: block;
								overflow: hidden;
								width: 40px;
								height: 30px;
								-webkit-tap-highlight-color: transparent;
								span {
									display: block;
									position: relative;
									width: 100%;
									height: 100%;
									z-index: 1;
									transition: transform 1s
											cubic-bezier(0.86, 0, 0.07, 1),
										transform-origin 1s
											cubic-bezier(0.86, 0, 0.07, 1),
										-webkit-transform 1s cubic-bezier(0.86, 0, 0.07, 1),
										-webkit-transform-origin 1s cubic-bezier(0.86, 0, 0.07, 1);
									transform: translateY(0);
									opacity: 0.8;
									&:before {
										content: '';
										display: block;
										position: absolute;
										top: 13px;
										width: 11px;
										height: 1px;
										z-index: 1;
										transform-origin: 100% 100%;
										transform: rotate(40deg) scaleY(1.1);
										background: #000;
										right: 50%;
										transition: transform 1s
												cubic-bezier(0.86, 0, 0.07, 1),
											transform-origin 1s
												cubic-bezier(0.86, 0, 0.07, 1),
											-webkit-transform 1s cubic-bezier(0.86, 0, 0.07, 1),
											-webkit-transform-origin 1s cubic-bezier(0.86, 0, 0.07, 1);
									}
									&:after {
										content: '';
										display: block;
										position: absolute;
										top: 13px;
										width: 11px;
										height: 1px;
										z-index: 1;
										background: #000;
										left: 50%;
										border-radius: 0 0.5px 0.5px 0;
										transform: rotate(-40deg) scaleY(1.1);
										transform-origin: 0% 100%;
										transition: transform 1s
												cubic-bezier(0.86, 0, 0.07, 1),
											transform-origin 1s
												cubic-bezier(0.86, 0, 0.07, 1),
											-webkit-transform 1s cubic-bezier(0.86, 0, 0.07, 1),
											-webkit-transform-origin 1s cubic-bezier(0.86, 0, 0.07, 1);
									}
								}
							}
						}
						.hostjane-main-About-Nav__wrapper__content__menu__action__button {
							margin-left: 24px;
							float: left;

							a {
								cursor: pointer;
								display: inline-block;
								text-align: center;
								white-space: nowrap;
								background: #0071e3;
								color: #fff;
								font-size: 16px;
								line-height: 1.3;
								font-weight: 400;
								letter-spacing: -0.01em;
								min-width: 23px;
								padding-left: 11px;
								padding-right: 11px;
								padding-top: 4px;
								padding-bottom: 4px;
								border-radius: 20px;
								margin-top: -1px;
								text-decoration: none;
								span {
									position: absolute;
									clip: rect(1px, 1px, 1px, 1px);
									-webkit-clip-path: inset(
										0px 0px 99.9% 99.9%
									);
									clip-path: inset(0px 0px 99.9% 99.9%);
									overflow: hidden;
									height: 1px;
									width: 1px;
									padding: 0;
									border: 0;
									top: auto;
									left: auto;
								}
								&:hover {
									background: #147ce5;
								}
							}
						}
					}
				}
			}
		}
	}
`;

const AboutNav = ({
	navTitleLink,
	navTitle,
	navLinks,
	btnText,
	btnLink,
	fullWidth,
	navLogo,
	smallNavIcon,
}) => {
	const [navActive, setNavActive] = useState(false);
	return (
		<AboutNavWrapper
			className="hostjane-main-About-Nav"
			fullWidth={fullWidth}
			smallNavIcon={smallNavIcon}
		>
			<div className="hostjane-main-About-Nav__wrapper">
				<div className="hostjane-main-About-Nav__wrapper__background" />
				<div className="hostjane-main-About-Nav__wrapper__content">
					<div className="hostjane-main-About-Nav__wrapper__content__title">
						<a href="/">
							{navLogo}
							{navTitle}
						</a>
					</div>
					<div className="hostjane-main-About-Nav__wrapper__content__menu">
						<a
							href="#_"
							className="hostjane-main-About-Nav__wrapper__content__menu__anchor-open"
						>
							<span>Open menu</span>
						</a>
						<a
							href="#_"
							className="hostjane-main-About-Nav__wrapper__content__menu__anchor-close"
						>
							<span>Close menu</span>
						</a>
						<div
							className={`hostjane-main-About-Nav__wrapper__content__menu__tray ${
								navActive && 'active'
							}`}
						>
							<ul>
								{navLinks.map(({ link, href }) => {
									return (
										<li className="menu-item">
											<a
												href={href}
												className={
													navActive
														? 'active'
														: undefined
												}
											>
												{link}
											</a>
										</li>
									);
								})}
							</ul>
						</div>
						<div className="hostjane-main-About-Nav__wrapper__content__menu__action">
							<div
								onClick={() => setNavActive(!navActive)}
								className="hostjane-main-About-Nav__wrapper__content__menu__action__menu-cta"
							>
								<label>
									<span />
								</label>
							</div>
							<div className="hostjane-main-About-Nav__wrapper__content__menu__action__button">
								<a href={btnLink}>
									{btnText}
									<span>{btnText}</span>
								</a>
							</div>
						</div>
					</div>
				</div>
				{/* <hr /> */}
			</div>
		</AboutNavWrapper>
	);
};

export default AboutNav;
